import {
    GETROLEDROPLIST_SUCCESS,
    GETROLEDROPLIST_FAILED,
    RESET_GETROLEDROPLIST,
    LOADING_GETROLEDROPLIST,
    NETWORK_ERROR_GETROLEDROPLIST,
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_GETROLEDROPLIST:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case GETROLEDROPLIST_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case GETROLEDROPLIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_GETROLEDROPLIST:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_GETROLEDROPLIST:
            return (state = initialState);
        default:
            return state;
    }
};